export default function adminEligibilitiesReducer(state = {
  groups: [],
  abm_codes: [],
  wse_bands: [],
  postcodes: [],
  sub_zones: [],
  zones: [],
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_ELIGIBILITIES_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case 'GET_ELIGIBILITIES_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        abm_codes: action.payload.abm_codes,
        groups: action.payload.groups,
        zones: action.payload.zones,
        sub_zones: action.payload.sub_zones,
        postcodes: action.payload.postcodes,
        wse_bands: action.payload.wse_bands,
      };
    }
    case 'GET_ELIGIBILITIES_REJECTED': {
      return { ...state };
    }
    default: {
      return { ...state };
    }
  }
}
